import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { initPixel, trackPageView } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-sage/30 selection:text-brand-navy" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2746653289031064&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <OpeningHook data-id="element-4" />
      <Problem data-id="element-5" />
      <WhyFailed data-id="element-6" />
      <Mechanism data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <ForWhom data-id="element-9" />
      <HowItWorks data-id="element-10" />
      <Proof data-id="element-11" />
      <FAQ data-id="element-12" />
      <Offer data-id="element-13" />
      <Footer data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}